import React from "react";
import Header from "../../../../Components/Header";
import SalesReturn from "./SalesReturn";
import { useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";

const ViewSalesReturn = () => {
  const location = useLocation();

  const deliveryNoteId = location.state?.deliveryNoteId;

  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				  <title>Sales Return - View</title>
			  </Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column " style={{flexGrow:'1'}}>
        <SalesReturn deliveryNoteId={deliveryNoteId} />
      </div>
  </div>
  );
};

export default ViewSalesReturn;
